import { useEffect, useState } from "react";
import { subscribeToLeadership } from "../utils/recordingTabCoordinator";

// Whether this browser tab is the elected "leader" responsible for actually
// capturing microphone audio and driving the upload pipeline. Non-leader
// tabs should render read-only recording status instead of starting their
// own MediaRecorder.
const useRecordingTabLeadership = (): boolean => {
  const [isLeader, setIsLeader] = useState(false);

  useEffect(() => subscribeToLeadership(setIsLeader), []);

  return isLeader;
};

export { useRecordingTabLeadership };
